import React, { useState, useEffect } from "react";
import "../style/Carousel.css";

import Magazines from "../assets/images/MagazinesHome.jpg";
import Events from "../assets/images/EventsHome.jpg";
import Digital from "../assets/images/DigitalHome.jpg";

const slides = [
  {
    image: Magazines,
    title: "Publishing & Magazines",
    description: "International editorial visibility for dental and medical companies."
  },
  {
    image: Events,
    title: "Trade Show Services",
    description: "We help brands connect with distributors and buyers at global exhibitions."
  },
  {
    image: Digital,
    title: "Digital Marketing",
    description: "Targeted campaigns, content distribution and measurable performance."
  }
];

const HomeServicesCarousel = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const getPosition = (index) => {
    const prev = (current - 1 + slides.length) % slides.length;
    const next = (current + 1) % slides.length;

    if (index === current) return "active";
    if (index === prev) return "prev";
    if (index === next) return "next";
    return "hidden";
  };

  return (
    <div className="services-carousel myBgAcqua">
      <div className="services-carousel-track">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`services-slide ${getPosition(index)}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="services-slide-overlay" />
            <div className="services-slide-content">
              <h2>{slide.title}</h2>
              <p>{slide.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="services-carousel-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`services-dot ${index === current ? "active" : ""}`}
            onClick={() => setCurrent(index)}
            aria-label={`Vai alla slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HomeServicesCarousel;